import { render, staticRenderFns } from "./upLoginPwd.vue?vue&type=template&id=22321e70&scoped=true"
import script from "./upLoginPwd.vue?vue&type=script&lang=js"
export * from "./upLoginPwd.vue?vue&type=script&lang=js"
import style0 from "./upLoginPwd.vue?vue&type=style&index=0&id=22321e70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22321e70",
  null
  
)

export default component.exports